/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, CardMedia, Grid, IconButton, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { MFTextField } from '../../lib/formik';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import MFCheckbox from '../../lib/formik/Checkbox';
import { NomineeType } from '../../redux-store/types/api-types';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkValidationBasedOnDate,
  getApplicantName,
  getCurrentStep,
  getNomineeRelation,
  ifPushToXalt,
  isMinor,
  navigateToNextStep,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { DatePicker } from '../../lib/formik/DatePicker';
import { ConfirmationDialog } from '../commonComponents';
import { nomineeDetailsSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  NomineeRelations,
  nomineeValidationDate,
  USER_ROLES,
  otherRelations,
  SAVE_LATER_VALIDATION_CHECK,
} from '../../utils/constant';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';

type updateNominee = NomineeType & {
  Relationship: string | null;
};

type Values = {
  doNotWishToNominate: boolean;
  nominees: updateNominee[];
  saveType: string;
};

const newNominee: updateNominee = {
  nomineeName: '',
  nomineeRelationship: '',
  dateOfBirth: null,
  nomineePercentage: 0,
  guardianName: '',
  isActive: true,
  Relationship: '',
  nominationDocumentCheck: false,
  nomineePan: '',
  nomineeGuardianPan: '',
};

const initialValues: Values = {
  doNotWishToNominate: false,
  nominees: [newNominee],
  saveType: 'save and proceed',
};

const Nominee = ({
  nomineeName,
  index,
  values,
  hasPOA,
  createdAt,
  ifXalt,
}: {
  nomineeName: number;
  index: number;
  values: Values;
  hasPOA: boolean | undefined;
  createdAt: string;
  ifXalt: boolean;
}): JSX.Element => {
  const { dateOfBirth = '' } = values.nominees[index];
  const { setFieldValue } = useFormikContext();

  return (
    <>
      {hasPOA && (
        <Grid item xs={12}>
          <MFCheckbox
            name={`nominees.${index}.nominationDocumentCheck`}
            label={'Wish to upload Nomination Form'}
            sx={{ my: 2 }}
            onChange={({ target: { checked } }) => {
              values.nominees.map((_nominee, ind) => {
                setFieldValue(`nominees.${ind}.nominationDocumentCheck`, checked);
              });
            }}
            disabled={index >= 1}
          />
        </Grid>
      )}
      {!values.nominees[index].nominationDocumentCheck && (
        <>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineeName`}
              label={`Nominee Name ${nomineeName} *`}
              placeholder={`Enter Nominee Name ${nomineeName}`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={`nominees.${index}.Relationship`}
              label="Nominee Relationship *"
              items={(ifXalt ? NomineeRelations.concat(otherRelations) : NomineeRelations)
                .filter((relation) => {
                  const { nominees } = values;
                  const selectedRelations = nominees
                    .filter(
                      (nominee, ind) =>
                        ind !== index &&
                        nominee.Relationship &&
                        nominee.isActive &&
                        ['MOTHER', 'FATHER', 'SPOUSE'].includes(
                          nominee?.Relationship?.toUpperCase()
                        )
                    )
                    .map((nominee) => nominee.Relationship);
                  return !selectedRelations.includes(relation);
                })
                .map((relation) => ({
                  key: relation,
                  value: relation,
                }))}
            />
            {values.nominees.map((nominee, idx: number) => {
              if (nominee.Relationship === 'OTHERS' && idx === index && !ifXalt) {
                return (
                  <MFTextField
                    name={`nominees.${index}.nomineeRelationship`}
                    label="Please Specify Relationship *"
                    placeholder={`Enter Nominee Relationship`}
                  />
                );
              }
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label={'Date of birth *'}
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              placeholder={'Enter Date of birth'}
              name={`nominees.${index}.dateOfBirth`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineePercentage`}
              label="Nominee % *"
              placeholder="Enter Nominee %"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`nominees.${index}.nomineePan`}
              label={`Nominee PAN ${
                checkValidationBasedOnDate(createdAt, nomineeValidationDate) ? '*' : ''
              }`}
              placeholder="Enter Nominee PAN"
              inputProps={{ style: { textTransform: 'uppercase' } }}
              onChange={(e) => {
                setFieldValue(`nominees.${index}.nomineePan`, e.target.value.toUpperCase());
              }}
            />
          </Grid>

          {isMinor(dateOfBirth ? dateOfBirth : '') && (
            <>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`nominees.${index}.guardianName`}
                  label="Guardian Name *"
                  placeholder="Enter Guardian Name"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={`nominees.${index}.nomineeGuardianPan`}
                  label={`Guardian PAN ${
                    checkValidationBasedOnDate(createdAt, nomineeValidationDate) ? '*' : ''
                  }`}
                  placeholder="Enter Guardian Pan"
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onChange={(e) => {
                    setFieldValue(
                      `nominees.${index}.nomineeGuardianPan`,
                      e.target.value.toUpperCase()
                    );
                  }}
                />
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
};

export default function NomineeDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [nomineesData, setNomineesData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [nomineeToDelete, setNomineeToDelete] = useState<{
    nominee: Partial<NomineeType>;
    index: number;
  } | null>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const path = location.pathname;
  const ifXalt = ifPushToXalt(application?.pushDataTo || '');

  const onSubmit = async (values: Values) => {
    try {
      const {
        nominees: existingNominees = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { nominees, doNotWishToNominate, saveType } = values;
      const updatedPayload = {
        ...application,
        doNotWishToNominate,
        nominees: doNotWishToNominate
          ? []
          : nominees.map((nominee, index) => {
              const { id = null } = existingNominees[index] || {};
              if (nominee.id === id) {
                const { Relationship, ...rest } = nominee;
                if (nominees[index].nominationDocumentCheck) {
                  return {
                    ...(existingNominees[index] || {}),
                    ...rest,
                    nomineeName: null,
                    nomineeRelationship: null,
                    dateOfBirth: null,
                    nomineePercentage: null,
                    guardianName: null,
                    nomineePan: null,
                    nomineeGuardianPan: null,
                  };
                } else {
                  return {
                    ...(existingNominees[index] || {}),
                    ...rest,
                    nomineeRelationship: ifXalt
                      ? Relationship
                      : getNomineeRelation(Relationship)
                      ? Relationship
                      : removeSingleQuote(nominee.nomineeRelationship),
                    dateOfBirth: !nominee.dateOfBirth
                      ? null
                      : new Date(nominee.dateOfBirth).toISOString(),
                    isActive: nominee.isActive && !doNotWishToNominate,
                    nomineeName: removeSingleQuote(rest.nomineeName),
                    guardianName: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                      ? removeSingleQuote(rest.guardianName)
                      : null,
                    nomineeGuardianPan: isMinor(nominee.dateOfBirth ? nominee.dateOfBirth : '')
                      ? removeSingleQuote(rest.nomineeGuardianPan)
                      : null,
                  };
                }
              }
              const { Relationship, ...rest1 } = nominees[index];
              if (rest1.nominationDocumentCheck) {
                return {
                  ...rest1,
                  nomineeName: null,
                  nomineeRelationship: null,
                  dateOfBirth: null,
                  nomineePercentage: null,
                  guardianName: null,
                  nomineePan: null,
                  nomineeGuardianPan: null,
                };
              } else {
                return {
                  ...rest1,
                  nomineeRelationship: ifXalt
                    ? Relationship
                    : removeSingleQuote(rest1.nomineeRelationship),
                  nomineeName: removeSingleQuote(rest1.nomineeName),
                  guardianName: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                    ? removeSingleQuote(rest1.guardianName)
                    : null,
                  nomineeGuardianPan: isMinor(rest1.dateOfBirth ? rest1.dateOfBirth : '')
                    ? removeSingleQuote(rest1.nomineeGuardianPan)
                    : null,
                };
              }
            }),
      };
      const isSaveLater = saveType !== 'save and proceed';
      const checkApplication = applicationComparison(
        {
          ...application,
          nominees: application?.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
        },
        {
          ...updatedPayload,
          nominees: updatedPayload.nominees?.sort(
            (nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)
          ),
          currentStep:
            !!currentStep &&
            currentStep > getCurrentStep(application?.applicationType || '', path, isSaveLater) - 1
              ? currentStep
              : getCurrentStep(application?.applicationType || '', path, isSaveLater),
        }
      );
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status === 'sent_to_amc_approver' &&
                    hasPOA &&
                    USER_ROLES.SUBDISTRIBUTOR === role
                  ? 'draft'
                  : status,
              currentStep: getCurrentStep(application?.applicationType || '', path, isSaveLater),
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || ''
          ),
          { id, applicant1ReferenceId }
        );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || ''
          ),
          { id, applicant1ReferenceId }
        );
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  useEffect(() => {
    const { nominees = [], doNotWishToNominate = false } = application || {};
    setNomineesData({
      ...nomineesData,
      doNotWishToNominate: doNotWishToNominate,
      // nominees.length
      //   ? false
      //   : doNotWishToNominate === null
      //   ? true
      //   : doNotWishToNominate,
      nominees: nominees.length
        ? nominees.map((nominee) => ({
            ...nominee,
            Relationship: ifXalt
              ? nominee.nomineeRelationship
              : getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
              ? nominee.nomineeRelationship
                ? nominee.nomineeRelationship.toUpperCase()
                : nominee.nomineeRelationship
              : 'OTHERS',
            nomineeRelationship: ifXalt
              ? ''
              : getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
              ? ''
              : nominee.nomineeRelationship,
            nominationDocumentCheck:
              nominee.nominationDocumentCheck === null && application?.hasPOA
                ? true
                : nominee.nominationDocumentCheck,
            nomineePercentage: nominee.nomineePercentage || 0,
          }))
        : [],
    });
  }, [application]);

  return (
    <Formik
      initialValues={nomineesData}
      onSubmit={onSubmit}
      enableReinitialize={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            nomineeDetailsSchema(
              application?.createdAt || '',
              application?.applicants,
              ifPushToXalt(application?.pushDataTo || '')
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes displayContent={'Contributor(s) have the option to choose nominee'} />
          <Grid item xs={12}>
            <MFCheckbox
              // disabled={!!values.nominees.length}
              disabled
              name="doNotWishToNominate"
              label="I do not wish to nominate."
              sx={{ letterSpacing: '1px' }}
              onChange={({ target: { checked } }) => {
                const updatedNominees = !checked
                  ? [
                      ...values.nominees,
                      {
                        ...newNominee,
                        nominationDocumentCheck: application?.hasPOA
                          ? true
                          : newNominee.nominationDocumentCheck,
                      },
                    ]
                  : values.nominees;
                setValues({
                  ...nomineesData,
                  doNotWishToNominate: checked,
                  nominees: updatedNominees.map((nominee) => ({
                    ...nominee,
                    nomineePercentage: 100,
                    isActive: !checked,
                  })),
                });
              }}
              checked={values.doNotWishToNominate}
            />
          </Grid>
          {values.nominees.map((nominee, index) => (
            <React.Fragment key={index}>
              <SubHeading
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}>
                {getApplicantName(index + 1, true)} Nominee Details
                {values.nominees?.length > 1 && (
                  <Box
                    sx={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => setNomineeToDelete({ nominee, index })}>
                    <Typography
                      sx={{
                        color: 'rgba(196, 42, 51, 0.8)',
                        fontSize: 12,
                        ml: 'auto',
                        letterSpacing: '-0.2px',
                        cursor: 'pointer',
                      }}>
                      Remove Nominee{' '}
                    </Typography>
                    <IconButton sx={{ p: '2px' }}>
                      <CardMedia
                        component="img"
                        src="/images/delete-red.svg"
                        alt="Delete Icon"
                        sx={{ width: 'unset' }}
                      />
                    </IconButton>
                  </Box>
                )}
              </SubHeading>
              <Nominee
                nomineeName={index + 1}
                index={index}
                key={index}
                values={values}
                hasPOA={application?.hasPOA}
                createdAt={application?.createdAt || ''}
                ifXalt={ifXalt}
              />
            </React.Fragment>
          ))}
          {values.nominees.length < 3 && (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  mt: 2,
                }}
                onClick={() =>
                  setValues({
                    ...values,
                    nominees: [
                      ...values.nominees,
                      {
                        ...newNominee,
                        nomineePercentage: values.nominees.length ? 0 : 100,
                        nominationDocumentCheck: application?.hasPOA
                          ? values.nominees.length === 0
                            ? true
                            : values.nominees[0].nominationDocumentCheck
                          : newNominee.nominationDocumentCheck,
                      },
                    ],
                    doNotWishToNominate: false,
                  })
                }>
                Add Nominee
              </Button>
            </Grid>
          )}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                nominees: values.nominees.map((nominee) => ({
                  ...nominee,
                  nomineeRelationship: ifXalt
                    ? nominee.Relationship
                    : nominee.Relationship === 'OTHERS'
                    ? nominee.nomineeRelationship
                    : nominee.Relationship,
                })),
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                nominees: values.nominees.map((nominee) => ({
                  ...nominee,
                  nomineeRelationship: ifXalt
                    ? nominee.Relationship
                    : nominee?.Relationship === 'OTHERS'
                    ? nominee.nomineeRelationship
                    : nominee?.Relationship,
                })),
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
          <ConfirmationDialog
            message={'Are you sure you want to delete nominee ?'}
            open={nomineeToDelete !== null}
            setOpen={() => setNomineeToDelete(null)}
            onSave={async () => {
              try {
                const { id } = application || {};
                const remainedApplicants = values.nominees.map((nominee, i) => {
                  if (i === nomineeToDelete?.index) {
                    return {
                      ...nominee,
                      isActive: false,
                    };
                  }
                  return nominee;
                });
                const sortedNominees = remainedApplicants.filter((applicant) => applicant.isActive);
                setNomineeToDelete(null);
                if (id && nomineeToDelete?.nominee.id) {
                  await dispatch(
                    updateApplication({
                      body: {
                        ...application,
                        nominees: remainedApplicants.map((nominee: updateNominee) => {
                          const { Relationship, ...rest } = nominee;
                          return {
                            ...rest,
                            nomineeRelationship: getNomineeRelation(Relationship)
                              ? Relationship
                              : nominee.nomineeRelationship,
                          };
                        }),
                        doNotWishToNominate:
                          sortedNominees.length === 0 ? true : values.doNotWishToNominate,
                        status:
                          !application?.hasPOA &&
                          AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                          application?.status !== 'draft' &&
                          applyRoleBasedStatus(role)
                            ? 'sent_to_amc_approver'
                            : application?.status === 'sent_to_amc_approver' &&
                              application?.hasPOA &&
                              USER_ROLES.SUBDISTRIBUTOR === role
                            ? 'draft'
                            : application?.status,
                      },
                      applicationId: id,
                    })
                  );
                  return;
                }
                setValues({
                  ...values,
                  nominees: sortedNominees,
                  doNotWishToNominate:
                    sortedNominees.length === 0 ? true : values.doNotWishToNominate,
                });
              } catch (e) {
                console.error((e as Error).message);
              }
            }}
            onCancel={() => setNomineeToDelete(null)}
          />
        </Grid>
      )}
    </Formik>
  );
}
